// extracted by mini-css-extract-plugin
export default {"container_checkbox_delete_folders":"DeleteFolders_container_checkbox_delete_folders__7p4AS","subtitle_notifications":"DeleteFolders_subtitle_notifications__u9gFK"};